"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMeasure = void 0;
const resize_observer_1 = require("@juggle/resize-observer");
const react_1 = require("react");
const INITIAL_RECT = {
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0,
};
const useMeasure = () => {
    const [element, setElement] = (0, react_1.useState)(null);
    const [rect, setRect] = (0, react_1.useState)(INITIAL_RECT);
    const [boundingClientRect, setBoundingClientRect] = (0, react_1.useState)(INITIAL_RECT);
    const observer = (0, react_1.useMemo)(() => new resize_observer_1.ResizeObserver((entries) => {
        if (entries[0]) {
            const [{ contentRect: { bottom, height, left, right, top, width, x, y }, target, },] = entries;
            setRect({ bottom, height, left, right, target, top, width, x, y });
            setBoundingClientRect(target.getBoundingClientRect());
        }
    }), []);
    (0, react_1.useLayoutEffect)(() => {
        if (!element) {
            return undefined;
        }
        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [element, observer]);
    return [setElement, rect, boundingClientRect];
};
exports.useMeasure = useMeasure;
//# sourceMappingURL=useMeasure.js.map